import type {
  BillingPayment,
  BillingSnapshot,
  PaymentStatus,
} from '@/components/billing/billing-types';
import type { BillingApiData } from '@/hooks/use-billing';

function mapPaymentStatus(status: PaymentStatus): PaymentStatus {
  return status;
}

function mapPayment(
  payment: BillingApiData['payments'][number]
): BillingPayment {
  return {
    id: payment.id,
    date: payment.dueAt,
    amount: payment.amount,
    currency: payment.currency,
    status: mapPaymentStatus(payment.status),
    description: payment.description,
    paymentUrl: payment.paymentUrl,
  };
}

export function mapBillingApiToSnapshot(data: BillingApiData): BillingSnapshot {
  const { subscription, payments } = data;

  if (!subscription) {
    return {
      plan: null,
      nextPaymentAt: null,
      hasStoredPaymentMethod: false,
      payments: [],
    };
  }

  const sortedPayments = payments
    .slice()
    .sort((a, b) => b.dueAt.localeCompare(a.dueAt));

  return {
    plan: {
      name: subscription.plan.displayName,
      priceAmount: subscription.amount,
      currency: subscription.currency,
    },
    nextPaymentAt: subscription.nextPaymentAt,
    hasStoredPaymentMethod: subscription.hasStoredPaymentMethod,
    payments: sortedPayments.map(mapPayment),
  };
}
